import React from 'react';
import { ReactComponent as LoadingIcon } from '~assets/loading.svg';

import { Container } from './styles';

type Props = {
  content: string;
  /** Área menor (ex.: só a tabela), evita “vazio” enorme na página */
  compact?: boolean;
}

export function LoadingContainer({ content, compact = false }: Props) {
  return (
    <Container $compact={compact}>
      <LoadingIcon />
      <p>Carregando {content}...</p>
    </Container>
  );
}

